import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CommanDialog = ({ visible, handleClose, handleFun, message, loader, type, yesLabel, noLabel }) => {
    // Determine the type dynamically if not explicitly provided
    let resolvedType = type;
    if (!resolvedType && message) {
        const msgLower = message.toLowerCase();
        if (
            msgLower.includes('delete') || 
            msgLower.includes('remove') || 
            msgLower.includes('deactive') || 
            msgLower.includes('reject') || 
            msgLower.includes('erase') || 
            msgLower.includes('logout')
        ) {
            resolvedType = 'delete';
        } else if (
            msgLower.includes('submit') || 
            msgLower.includes('approve') || 
            msgLower.includes('active') || 
            msgLower.includes('save') || 
            msgLower.includes('success')
        ) {
            resolvedType = 'success';
        } else if (
            msgLower.includes('continue') || 
            msgLower.includes('change') || 
            msgLower.includes('sure')
        ) {
            resolvedType = 'warning';
        } else {
            resolvedType = 'info';
        }
    }
    if (!resolvedType) resolvedType = 'info';

    // Status themes configuration
    let config = {
        title: 'Confirmation',
        icon: null,
        iconBg: 'rgba(59, 130, 246, 0.1)',
        iconColor: '#3b82f6',
        primaryBtnClass: 'sk-btn-confirm-info',
        titleColor: '#2563eb',
        btnIcon: 'fa-solid fa-check'
    };

    if (resolvedType === 'delete') {
        config = {
            title: 'Confirm Delete',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
            ),
            iconBg: 'rgba(239, 68, 68, 0.12)',
            iconColor: '#ef4444',
            primaryBtnClass: 'sk-btn-confirm-delete',
            titleColor: '#ef4444',
            btnIcon: 'fa-solid fa-trash-can'
        };
    } else if (resolvedType === 'warning') {
        config = {
            title: 'Warning',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            ),
            iconBg: 'rgba(245, 158, 11, 0.12)',
            iconColor: '#f59e0b',
            primaryBtnClass: 'sk-btn-confirm-warning',
            titleColor: '#d97706',
            btnIcon: 'fa-solid fa-triangle-exclamation'
        };
    } else if (resolvedType === 'success') {
        config = {
            title: 'Confirm Approval',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            ),
            iconBg: 'rgba(16, 185, 129, 0.12)',
            iconColor: '#10b981',
            primaryBtnClass: 'sk-btn-confirm-success',
            titleColor: '#059669',
            btnIcon: 'fa-solid fa-check'
        };
    } else {
        config = {
            title: 'Confirmation',
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
            ),
            iconBg: 'rgba(59, 130, 246, 0.12)',
            iconColor: '#3b82f6',
            primaryBtnClass: 'sk-btn-confirm-info',
            titleColor: '#2563eb',
            btnIcon: 'fa-solid fa-check'
        };
    }

    return (
        <div>
            <Dialog 
                visible={visible} 
                modal 
                onHide={handleClose} 
                className="modal-xsmall sk-confirmation-dialog" 
                draggable={false}
                showHeader={false}
            >
                <div className="sk-dialog-layout">
                    <div className="sk-dialog-body-row d-flex align-items-start gap-3">
                        <div 
                            className="sk-dialog-icon-circle d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: config.iconBg, color: config.iconColor }}
                        >
                            {config.icon}
                        </div>
                        <div className="sk-dialog-content flex-grow-1">
                            <h4 className="sk-dialog-title" style={{ color: config.titleColor }}>
                                {config.title}
                            </h4>
                            <p className="sk-dialog-message m-0 mt-2">
                                {message}
                            </p>
                        </div>
                    </div>
                    
                    <div className="sk-dialog-footer d-flex justify-content-end gap-2 mt-4">
                        <button 
                            className="sk-btn-confirm-secondary" 
                            onClick={handleClose}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-xmark" style={{ marginRight: '6px' }} />
                            {noLabel || 'No'}
                        </button>
                        
                        {loader ? (
                            <button 
                                className={`sk-btn-confirm-primary-base ${config.primaryBtnClass}`}
                                disabled
                            >
                                <div 
                                    className="spinner-border d-flex align-items-center" 
                                    role="status" 
                                    style={{ width: "16px", height: "16px" }}
                                >
                                    <span className="sr-only"></span>
                                </div>
                            </button>
                        ) : (
                            <button 
                                className={`sk-btn-confirm-primary-base ${config.primaryBtnClass}`}
                                onClick={handleFun}
                            >
                                <FontAwesomeIcon icon={config.btnIcon} style={{ marginRight: '6px' }} />
                                {yesLabel || 'Yes'}
                            </button>
                        )}
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default CommanDialog;
